import Api from 'libs/api';
import AuthService from 'services/Auth';

class DishesApi extends Api {
  constructor(restaurantID) {
    const resId = restaurantID || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/dishes`);
  }
}

export default DishesApi;
